import { render } from "./MailIcon.vue?vue&type=template&id=3de9c4ad"
import script from "./MailIcon.vue?vue&type=script&lang=js"
export * from "./MailIcon.vue?vue&type=script&lang=js"
script.render = render

export default script